(() => {
  function cartGroupKey(item) {
    return JSON.stringify([
      item?.product_id,
      item?.variant_id,
      item?.selling_plan_allocation?.selling_plan?.id ?? null,
      item?.properties ?? {}
    ]);
  }

  function groupCartItems(items = []) {
    const groups = [];
    const indexes = new Map();

    for (const item of items) {
      const groupKey = cartGroupKey(item);
      const existingIndex = indexes.get(groupKey);
      if (existingIndex === undefined) {
        indexes.set(groupKey, groups.length);
        groups.push({
          ...item,
          _cartKeys: [item.key],
          quantity: Number(item.quantity) || 0,
          final_line_price: Number(item.final_line_price) || 0,
          original_line_price: Number(item.original_line_price) || 0
        });
        continue;
      }

      const group = groups[existingIndex];
      group._cartKeys.push(item.key);
      group.quantity += Number(item.quantity) || 0;
      group.final_line_price += Number(item.final_line_price) || 0;
      group.original_line_price += Number(item.original_line_price) || 0;
    }

    return groups;
  }

  function isUpsellEligible(cart, config) {
    if (!cart || !config?.productHandle || cart.item_count !== 1 || cart.items?.length !== 1) return false;
    const [item] = cart.items;
    return item.handle === config.productHandle && Number(item.quantity) === 1;
  }

  function getAppliedDiscount(cart) {
    return Math.max(0, Number(cart?.total_discount) || 0);
  }

  function getLinePriceState(item) {
    const quantity = Math.max(0, Number(item?.quantity) || 0);
    const compareAtLinePrice = Math.max(0, Number(item?.compare_at_price) || 0) * quantity;
    const originalLinePrice = Math.max(compareAtLinePrice, Number(item?.original_line_price) || 0);
    // Shopify's final price already includes the applied pair discount. Never subtract it again.
    const finalLinePrice = Math.max(0, Number(item?.final_line_price) || 0);
    return {
      originalLinePrice,
      finalLinePrice,
      isDiscounted: originalLinePrice > finalLinePrice
    };
  }

  globalThis.KiddyViewCartLogic = Object.freeze({
    getAppliedDiscount,
    getLinePriceState,
    groupCartItems,
    isUpsellEligible
  });
})();
